<div class="data-platform-contact-flyout">
  <!-- Header -->
  <div class="flyout-header">
    <div class="flyout-header-left">
      <mat-icon class="header-icon">person</mat-icon>
      <div class="header-text">
        <div class="header-title">{{ displayName() }}</div>
        @if (detail()?.email && detail()?.email !== displayName()) {
          <div class="header-subtitle">{{ detail()?.email }}</div>
        }
        @if (detail()?.phone) {
          <div class="header-subtitle">{{ detail()?.phone }}</div>
        }
      </div>
    </div>
    <mat-icon class="close-icon" (click)="closeFlyout()">close</mat-icon>
  </div>

  @if (loading()) {
    <div class="loading-container">
      <mat-spinner diameter="32"></mat-spinner>
    </div>
  }

  @if (!loading() && detail()) {
    <!-- Only when consent exists: no consent shows nothing, like the profile flyout. -->
    @if (hasEmailConsent()) {
      <div class="consent-badge-row">
        <mat-icon class="consent-badge-icon has-consent">check_circle</mat-icon>
        <span class="consent-badge-label">{{ "data-platform.has-email-consent" | translate }}</span>
      </div>
    }

    <!-- Tags -->
    @if (detail()!.tags?.length > 0) {
      <div class="flyout-section">
        <div class="section-label">{{ "data-platform.tags" | translate }}</div>
        <div class="chips-row">
          @for (tag of detail()!.tags; track tag) {
            <span class="tag-chip">{{ tag }}</span>
          }
        </div>
      </div>
    }

    <!-- Identifiers -->
    @if (detail()!.identifiers?.length > 0) {
      <div class="flyout-row">
        <div class="flyout-data-group">
          <mat-expansion-panel [expanded]="true" class="mat-elevation-z0">
            <mat-expansion-panel-header [collapsedHeight]="'48px'" [expandedHeight]="'48px'">
              <mat-icon class="section-icon">badge</mat-icon>
              <span>{{ "data-platform.identifiers" | translate }}</span>
            </mat-expansion-panel-header>
            @for (id of identifiersView(); track id.value) {
              <div class="expansion-panel-row no-border">
                <div class="label">
                  <span class="id-type">{{ id.type }}</span>
                </div>
                <div class="value">
                  <span>{{ id.value }}</span>
                  @if (id.badge; as badge) {
                    <span class="source-badge" [matTooltip]="id.sourceTooltip">
                      <span>{{ badge.labelKey | translate }}</span>
                      @if (badge.logoUrl) {
                        <img class="source-badge__logo" [src]="badge.logoUrl" alt="" />
                      } @else {
                        <mat-icon class="source-badge__icon">{{ badge.icon }}</mat-icon>
                      }
                    </span>
                  }
                </div>
              </div>
            }
          </mat-expansion-panel>
        </div>
      </div>
    }

    <!-- Traits -->
    @if (traitEntries().length > 0) {
      <div class="flyout-row">
        <div class="flyout-data-group">
          <mat-expansion-panel [expanded]="true" class="mat-elevation-z0">
            <mat-expansion-panel-header [collapsedHeight]="'48px'" [expandedHeight]="'48px'">
              <mat-icon class="section-icon">tune</mat-icon>
              <span>{{ "data-platform.properties" | translate }}</span>
            </mat-expansion-panel-header>
            @for (entry of traitEntries(); track entry[0]) {
              <div class="expansion-panel-row no-border">
                <div class="label">
                  <span>{{ entry[0] }}</span>
                </div>
                <div class="value">
                  <span>{{ entry[1] }}</span>
                </div>
              </div>
            }
          </mat-expansion-panel>
        </div>
      </div>
    }

    <!-- Subscriptions -->
    @if (detail()!.subscriptions?.length > 0) {
      <div class="flyout-row">
        <div class="flyout-data-group">
          <mat-expansion-panel [expanded]="true" class="mat-elevation-z0">
            <mat-expansion-panel-header [collapsedHeight]="'48px'" [expandedHeight]="'48px'">
              <mat-icon class="section-icon">email</mat-icon>
              <span>{{ "data-platform.subscriptions" | translate }}</span>
            </mat-expansion-panel-header>
            <app-collapsible-list [items]="subscriptionsView()" [itemTemplate]="subRow"></app-collapsible-list>
            <ng-template #subRow let-sub>
              <div class="subscription-row">
                <div class="sub-header">
                  <span class="sub-channel">{{ sub.channel }}</span>
                  <span class="sub-status" [class.active]="sub.status === 'subscribed'" [class.inactive]="sub.status !== 'subscribed'">{{ sub.status }}</span>
                </div>
                @if (sub.listId) {
                  <span class="sub-list">{{ sub.listId }}</span>
                }
                @if (sub.subscribedAtDate) {
                  <span class="sub-date">{{ sub.subscribedAtDate | formatDate }}</span>
                }
              </div>
            </ng-template>
          </mat-expansion-panel>
        </div>
      </div>
    }

    <!-- Consent Log -->
    @if (detail()!.consentLog?.length > 0) {
      <div class="flyout-row">
        <div class="flyout-data-group">
          <mat-expansion-panel [expanded]="false" class="mat-elevation-z0">
            <mat-expansion-panel-header [collapsedHeight]="'48px'" [expandedHeight]="'48px'">
              <mat-icon class="section-icon">history</mat-icon>
              <span>{{ "data-platform.consent-log" | translate }}</span>
            </mat-expansion-panel-header>
            <div class="consent-timeline">
              <app-collapsible-list [items]="consentLogView()" [itemTemplate]="consentRow"></app-collapsible-list>
              <ng-template #consentRow let-entry>
                <div class="consent-entry">
                  <div class="consent-entry-header">
                    <mat-icon class="consent-entry-icon" [class.gave]="entry.status === 'granted'">
                      {{ entry.status === "granted" ? "check_circle" : "cancel" }}
                    </mat-icon>
                    <span class="consent-entry-type">{{ entry.type }}</span>
                    <span class="consent-entry-status">{{ entry.status }}</span>
                  </div>
                  <span class="consent-entry-date">{{ entry.recordedAtDate | formatDate }}</span>
                  @if (entry.versionDate) {
                    <span class="consent-entry-version">v{{ entry.versionDate }}</span>
                  }
                </div>
              </ng-template>
            </div>
          </mat-expansion-panel>
        </div>
      </div>
    }
  }
</div>
